import { getDesktop } from '@/desktop/desktop';
import { publicPath } from '@utils/public-path';

/**
 * API URLs, split from asset URLs (publicPath): in the browser the API is
 * same-origin behind BASE_URL; inside SKJV Desktop the renderer lives on
 * skjv://app while the API is the shell-managed server on 127.0.0.1.
 */
export function apiPath(path: string): string {
  const apiBase = getDesktop()?.apiBase;
  if (!apiBase) return publicPath(path);
  const clean = path.startsWith('/') ? path.slice(1) : path;
  return `${apiBase}/${clean}`;
}
